module.exports = __webpack_public_path__ + "img/plus-icon-black.c9ee13a2.png";